module.exports = __webpack_public_path__ + "static/img/1-5.5a0f605f.png";